import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_filter",
  "use": "icon-icon_general_filter-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_general_filter\">\n<path d=\"M38,13v0.1000004L26,27v11h-4V27L10,13.1000004V13H38 M40,11H8v2.8999996l12,13.8999996V40h8V27.7000008\n\tl12-13.8999996V11L40,11z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol